import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-graduated-imgs',
  templateUrl: './graduated-imgs.component.html',
  styleUrls: ['./graduated-imgs.component.scss']
})
export class GraduatedImgsComponent implements OnInit {

  pageData: any = {};

  constructor(private api: MainService) { }

  loadData() {

    this.api.getMediaGradList().subscribe(
      data => {
        //debugger
        console.log(data);
        this.pageData = data;
      }, error => {
        console.log(error);
      });
  }
  ngOnInit() {

    this.loadData();
    window.scrollTo(0, 0);
  }

}
